import { NavLink, useNavigate } from 'react-router-dom';
import React from 'react';
import { useApp } from '../store/AppContext.js';

const NAV: { to: string; label: string; icon: string }[] = [
  { to: '/vault', label: 'Vault', icon: '🔒' },
  { to: '/generator', label: 'Generator', icon: '🎲' },
  { to: '/security', label: 'Security', icon: '🛡️' },
  { to: '/sharing', label: 'Sharing', icon: '📤' },
  { to: '/orgs', label: 'Organisation', icon: '🏢' },
  { to: '/audit', label: 'Audit logs', icon: '📜' },
  { to: '/settings', label: 'Settings', icon: '⚙️' },
];

export function Layout({ children }: { children: React.ReactNode }) {
  const { user, logout, lock } = useApp();
  const navigate = useNavigate();
  const initial = (user?.email ?? '?')[0]?.toUpperCase();

  return (
    <div className="app-shell">
      <aside className="sidebar">
        <div className="brand">
          <span className="logo">🔐</span> Battini <span className="gradient-text">Vault</span>
        </div>
        <nav className="nav">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} className={({ isActive }) => (isActive ? 'active' : '')}>
              <span className="ic">{n.icon}</span>
              <span className="lbl">{n.label}</span>
            </NavLink>
          ))}
        </nav>
        <div className="nav" style={{ flex: '0' }}>
          <button className="ghost btn sm" style={{ justifyContent: 'flex-start' }} onClick={() => { lock(); navigate('/unlock'); }}>
            <span className="ic">🔓</span> <span className="lbl">Lock vault</span>
          </button>
        </div>
      </aside>
      <main className="main">
        <div className="topbar">
          <h1>{NAV.find((n) => location.pathname.startsWith(n.to))?.label ?? 'Battini Vault'}</h1>
          <div className="user-chip">
            <div className="avatar">{initial}</div>
            <div>
              <div style={{ color: 'var(--text)', fontSize: 13 }}>{user?.email}</div>
              <button onClick={() => logout()} className="ghost btn sm" style={{ padding: '2px 4px' }}>Sign out</button>
            </div>
          </div>
        </div>
        {children}
      </main>
    </div>
  );
}
